<template>
  <div>

    <svg id="chartDev"></svg>

    <div style="clear:both; margin-top:50px; font-size:13px;">
      Colorize:
      <button name="all" v-on:click="toggle('rootSvg')">rootSvg</button>
      <button name="all" v-on:click="toggle('clipPath')">clipPath</button>
      <button name="all" v-on:click="toggle('clipPath1')">clipPath1</button>
      <button name="all" v-on:click="toggle('clipPath2')">clipPath2</button>
      <button name="all" v-on:click="toggle('clipPath3')">clipPath3</button><br/><br/>
      Enable/Disable:
      <button name="all" v-on:click="toggleCP0()">clipPath enable/disable</button>
      <button name="all" v-on:click="toggleCP('1')">clip1</button>
      <button name="all" v-on:click="toggleCP('2')">clip2</button>
      <button name="all" v-on:click="toggleCP('3')">clip3</button><br/><br/>
      <button v-on:click="tick">Tick</button>
    </div>

    <div style="clear:both; margin-top:15px;">
      <button v-on:click="printingChart.emgEnable(undefined, false)">Uroflow</button>
      <button v-on:click="printingChart.emgEnable(true)">Uroflow + EMG</button>
      <button v-on:click="printingChart.emgEnable(true, true)">EMG</button>
    </div>

    <div style="clear:both; margin-top:15px;">
      <button v-on:click="printingChart.rescaleEmg([-10, 10])">rescaleEMG [-10, 10]</button>
      <button v-on:click="printingChart.rescaleEmg([-200, 200])">rescaleEMG [-200, 200]</button>
      <button v-on:click="printingChart.rescaleEmg([-500, 500])">rescaleEMG [-500, 500]</button>
      <select @change="onChange($event)">
        <option>5</option>
        <option>10</option>
        <option>15</option>
        <option>20</option>
        <option>25</option>
        <option>30</option>
        <option>35</option>
        <option>40</option>
        <option>45</option>
        <option>50</option>
        <option>60</option>
        <option>70</option>
        <option>80</option>
        <option>90</option>
        <option>100</option>
        <option>125</option>
        <option>150</option>
        <option>175</option>
        <option selected="selected">200</option>
        <option>500</option>
        <option>1000</option>
        <!-- <option>1000</option> -->
      </select>
    </div>

    <div style="clear:both; margin-top:15px;">
      <button v-on:click="printingChart.rescaleQura([0, 10, 2])">rescaleQura [0, 10, 2]</button>
      <button v-on:click="printingChart.rescaleQura([0, 25, 5])">rescaleQura [0, 25, 5]</button>
      <button v-on:click="printingChart.rescaleQura([0, 50, 10])">rescaleQura [0, 50, 10]</button>
    </div>

  </div>

</template>

<script>

import d3 from 'd3'
import GenericChart from '../GenericChart'

export default {
  props: ['title'],
  data () {
    return {
      printingChart: {},
      emgEnable: true
    }
  },
  components: {
  },
  methods: {
    onChange (event) {
      var vm = this
      console.log(event.target.value)
      let max = parseInt(event.target.value, 10)
      vm.printingChart.rescaleEmg([-max, max])
    },
    toggle: function (el) {
      if (d3.select('#' + el).style('visibility') === 'visible') { d3.select('#' + el).style('visibility', 'hidden') } else { d3.select('#' + el).style('visibility', 'visible') }
    },
    toggleCP0: function () {
      var e = d3.select('#clipped-content')
      if (e.attr('clip-path') === 'url(#clip)') { e.attr('clip-path', null) } else { e.attr('clip-path', 'url(#clip)') }
    },
    toggleCP: function (el) {
      var e = d3.select('.line' + el)
      if (e.attr('clip-path') === 'url(#clip' + el + ')') { e.attr('clip-path', null) } else { e.attr('clip-path', 'url(#clip' + el + ')') }

      if (el === '3') {
        let e = d3.select('.area')
        if (e.attr('clip-path') === 'url(#clip' + el + ')') { e.attr('clip-path', null) } else { e.attr('clip-path', 'url(#clip' + el + ')') }
      }
    },
    tick: function () {
      this.printingChart.tick()
    }

  },
  mounted () {
    var vm = this
    var data1 = []
    var data2 = []
    var data3 = []

    var config = {
      width: 750,
      height: 384,
      // margin           : { top:8, bottom:21, left:75, right:25 },
      margin: { top: 5, bottom: 16, left: 75, right: 50 },
      // interpolation: 'monotone',
      tickInterval: 1000,
      // orientation      : 'vertical',
      tickEvery: 5,
      chartType: 'dynamic',
      invisible_points: 0,
      totalTime: 19000,
      // EMGEnabled: true,
      translation: vm.$t,
      lineStrokeWidth: 1.5 // should match css "stroke-width"
    }

    this.printingChart = new GenericChart(document.querySelector('svg'), config)

    var tickInterval = 1000
    var nofPoints = 20
    var stretch = 100

    var i
    var lt = 0
    var first = -stretch
    var second = stretch * 2

    console.log('nofPoints', nofPoints)

    data3.push([new Date(0), 0])

    for (i = 0; i < nofPoints; i++) {
      if (i % 2 === 0) { if (i !== 0) { lt += first } } else { lt += second }

      if (lt === 1000) { first = -stretch * 2; second = stretch }
      if (lt === 0) { first = -stretch; second = stretch * 2 }

      if (i < 5) { lt = 0 }

      data1.push([new Date(i * tickInterval), lt])
      data2.push([new Date(i * tickInterval), lt / 20])

      if (i > 0) {
        var xx = 10
        for (let j = (i - 1) * tickInterval; j < i * tickInterval; j += 100) {
          data3.push([new Date(j + 100), (lt / 10) + 2 * xx])
          if (xx === 10) { xx = 0 } else { xx = 10 }
        }
      }
    }

    console.log(data3)

    console.log('Sending data', data1.length, data2.length, data3.length)

    /*
    var config = {

      width            : 800,
      height           : 380,
      margin           : { top:8, bottom:21, left:50, right:10 },
      interpolation    : 'monotone',
      tickInterval     : tickInterval,
      orientation      : 'horizontal',
      axisLabels       : 'disabled',
      tickEvery        : 5,

      chartType        : 'dynamic',
      invisible_points : 0,
      totalTime        : 19000,

      tickConfig: {
        vmic_y: [0, 500, 1000],
        qura_y: [0, 25, 50],
        verticalTicks: false
      }

    };
    */

    this.printingChart.initDrawing(data1, data2, data3)

    // var hs = this.printingChart.getHistory();
    //
    // this.printingChart = new GenericChart(document.querySelector('svg'), hs[0], hs[1], config);
    // this.printingChart.initDrawing();

    // Get all buttons with the name 'all' and store in a NodeList called 'buttons'
    vm.$nextTick(function () {
      var buttons = document.getElementsByName('all')
      for (let i = 0; i <= buttons.length; i++) {
        if (buttons[i]) buttons[i].click()
      }
    })
  }
}
</script>

<style>

#chartDev .axis {
  font: 10px sans-serif;
}

#chartDev .axis path,
#chartDev .axis line1, #chartDev .axis line2, #chartDev .axis line3 {
  fill: none;
  stroke: #dfdfdf;
  shape-rendering: crispEdges;
}

#chartDev .axis--x line, #chartDev .axis--y1 line, #chartDev .axis--y2 line, #chartDev .axis--y3 line {
  stroke: #dfdfdf;
}

#chartDev .line1, #chartDev .line2, #chartDev .line3 {
  fill: none;
  stroke-width: 1.5px;
}

#chartDev .line1 { stroke: red; }
#chartDev .line2 { stroke: green; }
/* #chartDev .line3 { stroke: black; } */
/* #chartDev .area { fill: none; } */
#chartDev .area { fill: black; }
</style>



// WEBPACK FOOTER //
// src/components/GenericChartDev.vue